import type { ReactNode } from 'react';
import { Button } from '../ui/Button';
import { LoginScreen } from './LoginScreen';
import { useAuth } from './store';

// Fail-closed: пока профиль не прочитан — ничего не показываем; нет профиля — отказ.
export function AuthGate({ children }: { children: ReactNode }) {
  const { status, session, error, signOut } = useAuth();

  if (status === 'loading') {
    return <main className="min-h-screen flex items-center justify-center text-ink-muted">Loading…</main>;
  }
  if (status === 'signed_out') return <LoginScreen />;
  if (status === 'denied') {
    return (
      <main className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-md bg-paper border border-line rounded-xl p-8 text-center">
          <h1 className="text-2xl font-bold mb-2">Access is restricted</h1>
          <p className="text-ink-muted mb-1">
            Only octopipoker.ai accounts can use OctopiPoker Roadmap.
          </p>
          {session?.user.email && <p className="mb-4">You are signed in as <b>{session.user.email}</b>.</p>}
          {error && <p className="text-danger mb-4">{error}</p>}
          <Button variant="secondary" onClick={() => void signOut()}>Sign out</Button>
        </div>
      </main>
    );
  }
  return <>{children}</>;
}
